import React from 'react';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { SectionLine } from '../components/SectionLine';
import { FormikPremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import useShippersFilter from '../useShippersFilter';
import RegularText from '../../ui/texts/RegularText';

const t = {
  section_header: 'Customer with client app access',
  info_1: "Available customers can be managed within the 'Customers tab'",
  info_2: 'Selecting an existing customer will auto fill customer data',
  error: 'No customer found, try again later',
  no_customer: 'No customer found',
  customer_label: 'Customer',
  search_label: 'Search customer',
  working_areas: 'Working areas',
};

export const ShipperSection = ({ ticketFormBodyData }) => {
  const { showErrors, isEdit, isReadOnly, ticketDetail, isDraft } = ticketFormBodyData;

  const shipperId = ticketFormBodyData.values.shipper_id;
  const hasShipper = shipperId !== '' && shipperId !== null && shipperId !== undefined;

  const initialShipperQuery = '';

  const {
    shipperOptions,
    shipperOptionsError,
    isLoadingShipperOptions,
    setSearch,
    setShipper,
    shipperWorkingAreas,
  } = useShippersFilter({
    initialQuery: initialShipperQuery,
  });

  const existingShipper = ticketDetail?.shipper || null;

  const shipperOptionsWithExistingShipper = [...shipperOptions];
  const existingShipperIsAlreadyInOptions = shipperOptions.some(
    (option) => option.value === existingShipper?.id
  );
  if (existingShipper && !existingShipperIsAlreadyInOptions) {
    shipperOptionsWithExistingShipper.push({
      value: existingShipper.id,
      shipperData: { ...existingShipper },
      label: <>{existingShipper.company_name}</>,
      display: existingShipper.company_name,
      search: `${existingShipper.company_name}`,
    });
  }

  const canEditShipper = (!isEdit && !isReadOnly) || isDraft;

  const ticketWorkingAreas = ticketDetail?.working_areas || [];

  let displayedWorkingAreas = shipperWorkingAreas;
  if (existingShipper && shipperWorkingAreas.length === 0) {
    displayedWorkingAreas = ticketWorkingAreas;
  }

  return (
    <SectionContainer>
      <SectionTitle>{t.section_header}</SectionTitle>
      <SectionBody>
        {canEditShipper && (
          <SectionLine>
            <RegularText>{t.info_1}</RegularText>
          </SectionLine>
        )}

        <SectionLine>
          <FormikPremiumInput
            type="select-with-search"
            onSearchChange={setSearch}
            onFieldChange={setShipper}
            options={shipperOptionsWithExistingShipper}
            isLoadingOptions={isLoadingShipperOptions}
            label={t.customer_label}
            searchLabel={t.search_label}
            showErrors={showErrors}
            customHasError={shipperOptionsError}
            optionsEmptyMssg={t.no_customer}
            isClereable={true}
            isDisabled={!canEditShipper}
            isRequired={true}
            initialValue={initialShipperQuery}
            name="shipper_id"
          />
        </SectionLine>

        {canEditShipper && (
          <>
            <SectionLine>
              <RegularText>{t.info_2}</RegularText>
            </SectionLine>
          </>
        )}

        {hasShipper && (
          <SectionLine>
            <RegularText>
              {t.working_areas}:{' '}
              {displayedWorkingAreas
                .map((workingArea) => {
                  let displayText = workingArea.full_name;
                  if (displayText === undefined || displayText === null || displayText === '') {
                    displayText = workingArea.slug;
                  }
                  return displayText;
                })
                .join(', ')}
            </RegularText>
          </SectionLine>
        )}
      </SectionBody>
    </SectionContainer>
  );
};
